// extracted by mini-css-extract-plugin
export default {"paymentIcon":"src-client-components-PaymentIcon-styles-___default__paymentIcon___eyDZu"};